import styled from 'styled-components';
import { ellipsisText } from 'Styles/styles';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  margin: 22px 15px 5px 0;
`;
Wrapper.displayName = 'Wrapper';

export const WrapperButtons = styled.div`
  display: flex;
  margin-left: auto;
  & > :first-child {
    margin-right: auto;
  }
  & > :last-child {
    margin-left: 8px;
  }
`;
WrapperButtons.displayName = 'WrapperButtons';

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.workspaceListItem};
  max-width: 320px;
  ${ellipsisText};
`;
Title.displayName = 'Title';
